import { css } from 'styled-components';

import { SternumTheme } from '@sternum/theme';
import { SnackbarAlertsTheme } from '@sternum/ui';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function SBOMLightSnackbarAlertsTheme(theme: SternumTheme): Partial<SnackbarAlertsTheme> {
  return {
    containerCss: css`
      gap: 4px;
    `,
  };
}
